import { useConnectContext } from 'features/Connect/features/Context/ConnectContextProvider';
import auth from 'utils/auth';
import { JobSeekingStatus } from 'types/types';
import { SESSION_STORAGE_KEYS } from 'utils/constants';
import { MatchQuizStatusStrings } from 'features/Connect/utils/connectEnums';

export function useShouldDisplayMatchesNotificationBanner(): boolean {
  const { candidateMatches } = useConnectContext();
  const isAuthenticated = auth.loggedIn();
  return isAuthenticated && candidateMatches?.pending?.length > 0;
}

export function useShouldDisplayMatchQuizBanner(): boolean {
  const isAuthenticated = auth.loggedIn();
  const user = auth.getUser();
  const isCandidateUser = user?.profile ? auth.isCandidateUser(user) : false;
  const { matchQuizStatus, jobSeekingStatus } = useConnectContext();

  return (
    isAuthenticated &&
    isCandidateUser &&
    jobSeekingStatus === JobSeekingStatus.OPEN_TO_WORK_AND_MATCHES &&
    matchQuizStatus !== MatchQuizStatusStrings.COMPLETE
  );
}

export function resetDismissedBanners() {
  sessionStorage.removeItem(SESSION_STORAGE_KEYS.DISMISSED_BANNERS);
}
